export const customDomainSyncInterval = 10; // In seconds
